import React from 'react'
import {
  Typography,
  Box,
  Button,
  TextField,
  MenuItem,
  Popover,
  FormControl,
} from "@mui/material";
import Landscape from '../../../../assets/VeoVideo/LandscapeVideoRatio.png'
import mobile from '../../../../assets/VeoVideo/mobile.png'
import { useWorkspace } from '../../../../contexts/WorkspaceContext';


const AspectRatioForVeo = () => {

  const {veoVideoResolution, setVeoVideoResolution} = useWorkspace()

  const SocialMediaPresets = [
  { id: 1, width: 1080, height: 1920, value: "1080 X 1920", ratio:"9:16", plateform:"Mobile video", img : mobile },
  { id: 2, width: 1920, height: 1080, value: "1920 X 1080",ratio:"16:9", plateform: "Landscape video",  img : Landscape },
];

const handleSelectResolution = (ele) => {
  setVeoVideoResolution(ele)
}

  return (
    <div>
       <Box sx={{ padding: "20px 20px 0px 0px" }}>
        <Box sx={{ display: "flex", flexDirection: "row", columnGap: "12px", marginBottom:"20px" }}>
                <Typography>Select video aspect ratio</Typography>
        </Box>
         <Box sx={{
          display: "flex",
          flexDirection: "row",
          gap: "20px",
          flexWrap: "wrap"
        }}>
          {SocialMediaPresets?.map((ele, index) => (
            <Box 
              key={index}
              onClick={() => handleSelectResolution(ele)} 
              sx={{
                cursor: "pointer",
                width: "285px",
                height: "308px",
                border: veoVideoResolution?.id == ele?.id ? "1px solid rgba(255, 255, 255, 0.30)" : "1px solid rgba(255, 255, 255, 0.10)",
                borderRadius: "16px",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                backgroundColor : veoVideoResolution?.id == ele?.id ? "#282D51" : "none",
                '&:hover':{
                  backgroundColor :  veoVideoResolution?.id != ele?.id ? "#282D51" : "none"
                },
              }}
            >
              <Box sx={{
                flex: 1,  // Takes up all available space except what's needed for text
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",  // Ensures image doesn't overflow
                position: "relative",
                width: "100%"
              }}>
                <img 
                  src={ele?.img} 
                  alt={"avatarPreview"} 
                  style={{
                    objectFit: "contain",
                    maxWidth: "100%",
                    maxHeight: "100%",
                    width: "auto",
                    height: "auto"
                  }}
                />
              </Box>
              <Box sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                marginTop: "10px"
              }}>
                <Typography sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "20px",
                  letterSpacing: "0.1px",
                  color: "#CAC4D0"
                }}>
                  {ele?.plateform}
                </Typography>
                <Typography sx={{
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  letterSpacing: "0.1px",
                  color: "#CAC4D0"
                }}>
                  {ele?.value}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
       </Box>
    </div>
  )
}

export default AspectRatioForVeo